import Table, { TableRow as _TableRow } from './Table';
export default Table;

export type TableRow = _TableRow;
